<template>
    <div class="test-plan-picker">
        <el-form-item label="测试目标">
            <el-select v-model="draft.goal" clearable placeholder="可选；选中后自动生成方案"
                       :disabled="disabled" style="width: 100%" @change="loadSuggestions(true)">
                <el-option v-for="goal in goals" :key="goal.value" :label="goal.label" :value="goal.value" />
            </el-select>
        </el-form-item>
        <template v-if="draft.goal">
            <el-form-item label="推荐方向">
                <el-select v-if="draft.goal !== 'OTHER'" v-model="selectedSuggestion" placeholder="请选择"
                           :loading="loading" :disabled="disabled" style="width: 100%" @change="applySuggestion">
                    <el-option v-for="item in suggestions" :key="item.id" :label="item.direction" :value="item.id" />
                </el-select>
                <el-input v-else v-model="draft.direction" maxlength="80" show-word-limit
                          placeholder="填写要验证的具体方向" :disabled="disabled" @input="emitDraft" />
                <div class="el-form-item__tip">系统按当前分类给出可执行方向；上线自动开始，7 天后自动结束。</div>
            </el-form-item>
            <el-form-item label="测试假设">
                <el-input v-model="draft.hypothesis" type="textarea" :rows="2" maxlength="500"
                          show-word-limit :disabled="disabled" @input="emitDraft" />
            </el-form-item>
            <el-form-item v-if="draft.direction" label="测试周期">
                <span>{{ lifecycleText }}</span>
            </el-form-item>
        </template>
    </div>
</template>

<script>
import axios from 'ts-axios-new';

const FALLBACK_GOALS = [
    ['ENTER', '提升进入率'], ['FINISH', '提升完成率'], ['SHARE', '提升分享率'],
    ['BALANCE', '兼顾进入与完成'], ['EXPAND_NEW', '探索新方向'],
    ['EXTEND_WINNER', '拓展优质方向'], ['SCALE_VALIDATION', '扩大样本验证'], ['OTHER', '其他'],
].map(([value, label]) => ({value, label}));

export default {
    name: 'TestPlanPicker',
    props: {
        modelValue: {type: Object, default: () => ({})},
        categories: {type: Array, default: () => []},
        categoryMap: {type: Object, default: () => ({})},
        disabled: {type: Boolean, default: false},
    },
    emits: ['update:modelValue'],
    data() {
        return {
            goals: FALLBACK_GOALS,
            suggestions: [],
            selectedSuggestion: '',
            loading: false,
            draft: {
                ...this.modelValue,
                goal: this.modelValue?.goal || (this.modelValue?.direction ? 'OTHER' : ''),
            },
        };
    },
    computed: {
        categoryName() {
            return this.categories.map(id => this.categoryMap[id]).filter(Boolean)[0] || '';
        },
        lifecycleText() {
            const labels = {WAITING: '待上线', RUNNING: '测试中', FINISHED: '已结束'};
            if (this.draft.starts_at && this.draft.ends_at) {
                return `${labels[this.draft.status] || ''} · ${this.draft.starts_at.slice(0, 10)} 至 ${this.draft.ends_at.slice(0, 10)}`;
            }
            return '图片实际上线后开始，连续 7 天；结束结果进入下一份周报';
        },
    },
    watch: {
        modelValue: {
            deep: true,
            handler(value) {
                this.draft = {...value, goal: value?.goal || (value?.direction ? 'OTHER' : '')};
            },
        },
        categoryName() {
            if (this.draft.goal && this.draft.goal !== 'OTHER') this.loadSuggestions(false);
        },
    },
    mounted() {
        if (this.draft.goal) this.loadSuggestions(false);
    },
    methods: {
        emitDraft() {
            this.$emit('update:modelValue', {...this.draft, duration_days: 7, status: this.draft.status || 'WAITING'});
        },
        async loadSuggestions(selectFirst) {
            if (!this.draft.goal) {
                this.draft = {};
                this.selectedSuggestion = '';
                this.emitDraft();
                return;
            }
            if (this.draft.goal === 'OTHER') {
                this.suggestions = [];
                this.selectedSuggestion = '';
                this.emitDraft();
                return;
            }
            this.loading = true;
            try {
                const params = new URLSearchParams({goal: this.draft.goal});
                if (this.categoryName) params.set('category', this.categoryName);
                const response = await axios.get(`/cms/v1/image/test-options?${params}`);
                const data = response.data?.data || response.data || {};
                this.goals = data.goals || FALLBACK_GOALS;
                this.suggestions = data.suggestions || [];
                const current = this.suggestions.find(item => item.direction === this.draft.direction);
                this.selectedSuggestion = current?.id || '';
                if ((selectFirst || !this.draft.direction) && this.suggestions.length) {
                    this.selectedSuggestion = this.suggestions[0].id;
                    this.applySuggestion(this.selectedSuggestion);
                }
            } finally {
                this.loading = false;
            }
        },
        applySuggestion(id) {
            const item = this.suggestions.find(suggestion => suggestion.id === id);
            if (!item) return;
            this.draft.direction = item.direction;
            this.draft.hypothesis = item.hypothesis;
            this.emitDraft();
        },
    },
};
</script>
